import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import API from '../../../api/api'
import { useSnackbar } from '../../../helpers/hooks/useSnackbar'

export const useDeleteAttendee = () => {
  const { t } = useTranslation(['attendees'])
  const { displaySnackbar } = useSnackbar()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  const deleteAttendee = async (attendeeId, eventId, attendeeRole, withRefund) => {
    try {
      setIsError(false)
      setIsLoading(true)

      await API.deleteUserFromEvent(attendeeId, eventId, attendeeRole, withRefund)
      displaySnackbar(
        withRefund
          ? t('attendees:notifications.attendeeDeletedWithRefund')
          : t('attendees:notifications.attendeeDeleted'),
      )
    } catch {
      displaySnackbar(t('attendees:notifications.couldNotDelete'), true)
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  return { deleteAttendee, isLoading, isError }
}
